"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveModal = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var components_1 = require("components");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
function getSourceName(currentFolder, parent) {
    if (currentFolder && currentFolder.name !== 'Root') {
        return currentFolder.name;
    }
    return parent.name;
}
var RemoveModal = function (props) {
    var titleText = props.currentBid
        ? (0, translation_1.getLocalization)('userfront/bidFileList/remove/areYouSure', [
            props.selectedItems.length.toString()
        ])
        : (0, translation_1.getLocalization)('userfront/fileList/remove/areYouSure', [
            props.selectedItems.length.toString(),
            getSourceName(props.currentFolder, parent)
        ]);
    var subText = props.currentBid
        ? (0, translation_1.getLocalization)('userfront/bidFileList/remove/deleteAll')
        : (0, translation_1.getLocalization)('userfront/fileList/remove/deleteAllRevisionHistory');
    return (React.createElement(components_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.removeIsOpen, close: function () { return props.setRemoveIsOpen(false); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
            React.createElement(ConfirmDialog_1.Exclamation, null),
            React.createElement("div", null,
                React.createElement("div", { className: 'title please-confirm-text' },
                    React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                React.createElement("div", { className: 'text' },
                    React.createElement("p", null, titleText),
                    React.createElement("p", null, subText)))), footer: React.createElement(React.Fragment, null,
            React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                    props.deleteFiles(props.selectedItems);
                    props.setRemoveIsOpen(false);
                } }),
            React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setRemoveIsOpen(false); } })) }));
};
exports.RemoveModal = RemoveModal;
